<template>
	<div 
		class="gb-cell gb-day white--text lighten-4 white" 
		tile 
		v-bind:class="classCell" 
		v-bind:style="styleUnitDay" 
		v-on:click= "onClickShowFreePersons"
	>
		<span class="black--text">{{ free.length }}</span>
	</div>
</template>
<script>
import { UNIT_WIDTH } from '../data/Const';

export default {
	name: 'GBDayFreePerson',
	props: [
		"schedule",
		"code",
	],
	data: function() {
		return {
			dartyfree: []
		};
	},
	computed: {
		free: function() {

			if (this.$store.getters.isExclusive)
				return this.dartyfree;

			if (!this.$store.getters.isShowFreePerson)
				return this.dartyfree;

			let calcfree = this.$store.getters.freePersonsBySchedule(this.schedule);
			this.updatedartyfree(calcfree);

			return calcfree;
		},
		classCell: function() {
			if (this.free.length == 0) {
				return "empty";
			} else if (this.free.length <= 2) {
				return "few";
			}
			return "";
		},
		styleUnitDay: function() {
			return {
				width: UNIT_WIDTH.DAY + 'px',
			};
		},
	},
	methods: {
		onClickShowFreePersons: function() {
			this.$emit("show-free-persons", { key: this.code, schedule: this.schedule });
		},
		updatedartyfree(free) {
		  this.dartyfree = free;
		},
	},
};
</script>
<style>
	.gb-day.few {
		background-color: yellow !important;
	}

	.gb-day.empty {
		background-color: red !important;
	}
</style>
